import { ErrorHandler, Injectable, Injector, inject } from '@angular/core';
import { LoggingService } from './logging.service';

@Injectable({
	providedIn: 'root'
})
export class ErrorHandlerService implements ErrorHandler {
	private readonly injector = inject<Injector>(Injector);

	private get logger() {
		return this.injector.get(LoggingService);
	}

	handleError(error: Error) {
		this.logger.logException(error); // Manually log exception
	}
}
